import {FormikValues} from 'formik'
import {useNavigate} from 'react-router-dom'
import {FC, useEffect, useMemo} from 'react'
import {initialStudent, Student, studentSchemas} from '../../modules/apps/student/students-list/core/_models'
//import {StudentEditModalForm} from '../../modules/apps/student/students-list/student-edit-modal/StudentEditModalForm'
import { createAdmission } from '../requests/frontend'
import { CTabForm } from '../../../_component/Form'
import { useQueryResponse, useQueryResponseData } from '../../modules/apps/profile/core/QueryResponseProvider'
import { useListView } from '../../modules/apps/profile/core/ListViewProvider'
import { useQuery } from '@tanstack/react-query'
import { QUERIES } from '../../../_metronic/helpers'
import { v1_get_request_api } from '../../../api/get'
import { createStudent, updateStudent } from '../../modules/apps/student/students-list/core/_requests'
import { fields } from '../../modules/apps/school/schools-list/core/_models'

export const AdmissionPage: FC = () => {
  const navigate = useNavigate()
  const submit = async (values: Student, actions: FormikValues) => {
    try {
      await createAdmission(values)
      alert(
        'Your application has been submitted successfully. You will be contacted shortly through the provided contact info.'
      )
      navigate('/')
    } catch (ex) {
      console.error(ex)
    } finally {
      actions.setSubmitting(false)
    }
  }
  

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])
  const {setItemIdForUpdate, itemIdForUpdate, setItemIdToView, itemIdToView} = useListView()
  const {refetch} = useQueryResponse()
  const students = useQueryResponseData()
  const id = useMemo(() => itemIdForUpdate || itemIdToView, [itemIdForUpdate, itemIdToView])
  const {
    isInitialLoading: isLoading,
    data: student,
    error,
  } = useQuery([QUERIES.STUDENTS_LIST + '/' + id], v1_get_request_api, {
    enabled: !!id,
    onError: (err) => {
      setItemIdForUpdate(undefined)
      setItemIdToView(undefined)
    },
    initialData: () => students.find((u) => u.id === id),
  })
  if (error) {
    setItemIdForUpdate(undefined)
    setItemIdToView(undefined)
    return null
  }

  return (
    <div id='kt_app_content' className='app-content flex-column-fluid mt-5'>
      {/*begin::Content container*/}
      <div id='kt_app_content_container' className='app-container container-xxl'>
        <div className='card'>
          <div className='card-header'>
            <h2 className='card-title m-auto'>Application Form</h2>
          </div>
          {/*begin::Admission*/}

           <CTabForm
                            isLoading={isLoading}
                            data={student || initialStudent}
                            update={updateStudent}
                            create={createStudent}
                            setItemIdForUpdate={setItemIdForUpdate}
                            refetch={refetch}
                            schema={studentSchemas}
                            fields={fields}
                          />
          {/* <StudentEditModalForm
            isStudentLoading={false}
            student={initialStudent}
            submit={submit}
            isExternal={true}
          /> */}
          {/*end::Admission*/}
        </div>
      </div>
      {/*end::Content container*/}
    </div>
  )
}
